const phone = null
const supportedLanguages = ['fr', 'ar']
const personalInfo = {
  phoneNumberMask: '#### ### ####'
}
const paymentMethods = {
  bankAccountMask: null
}

export {
  // auxiliary objects
  phone,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
